import api from "../../../services/api";
import { ModalAdicionarProdutorStyled } from "./style";
import { useEffect, useState } from "react";
import Loading from "../../Loading";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export const ModalTrocarFotoDestaque = ({
  material_id,
  buscarDados,
  state,
  deletarImagemAdministrar,
}) => {
  const [fotos, setFotos] = useState(false);
  const { register, handleSubmit, getValues } = useForm();

  function listarFotos() {
    api
      .get(`/material-vitrine/${material_id}/anexos`)
      .then((response) => {
        const filtrados = response.data.data.anexos.filter(
          (foto) => !foto.principal
        );
        setFotos(filtrados);
      })
      .catch((error) => {
        console.error("Listar Produtores Erro:", error);
        toast.error("Erro ao listar produtores. Tente novamente.");
      });
  }


  function atualizarImagemAdministrar() {
    api
      .patch(`/material-vitrine/${material_id}/anexos/${getValues("fotoDestaque")}`, {
        principal: true
      })
      .then((response) => {
        state(false);
        toast.success("Imagem atualizada como principal");
        buscarDados();
        deletarImagemAdministrar();
      })
      .catch((error) => {
        toast.error("Erro ao atualizar imagem");
      });
  }

  useEffect(() => {
    listarFotos();
  }, []);

  return (
    <ModalAdicionarProdutorStyled>
      {fotos ? (
        <div>
          <span className="close" onClick={() => state(false)}>
            X
          </span>
          <div>
            <h2>Selecionar outra foto destaque</h2>
            <div className="grid">
              {fotos.map((foto) => (
                <div key={foto.id} className="foto">
                  <input
                    {...register("fotoDestaque")}
                    type="radio"
                    name="fotoDestaque"
                    value={foto.id}
                  />
                  <label>{foto.nome}</label>
                  <img src={foto.url} alt={foto.nome} />
                </div>
              ))}
            </div>
            <button className="adicionar" onClick={handleSubmit(atualizarImagemAdministrar)}>
              Adicionar
            </button>
          </div>
        </div>
      ) : (
        <Loading className="loading" />
      )
      }
    </ModalAdicionarProdutorStyled >
  );
};
